import { swoopAPI } from '@/api'

export const getUser = () => swoopAPI.get('/api/v1/user/current')
export const isMfaEnabled = userEmail => swoopAPI.get('/api/v1/user/mfa-enabled', { params: { userEmail }, paramsSerializer: params => new URLSearchParams(params).toString() })
export const register = data => swoopAPI.post('/api/v1/user', data)
export const updateUser = data => swoopAPI.put('/api/v1/user', data)
export const updateUserContactInfo = data => swoopAPI.patch('/api/v1/user/contactInfo', data)
export const activateBulkUser = params => swoopAPI.post('/api/v1/user/activateBulkUser', null, { params })
export const updateMfaEnabled = active => swoopAPI.put('/api/v1/user/mfa-enabled', null, { params: { active } })
